var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAgendamento = function SvgIconAgendamento(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4270",
    "data-name": "Ret\\xE2ngulo 4270",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "#f78a2f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9816",
    "data-name": "Grupo 9816",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9815",
    "data-name": "Grupo 9815",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6393",
    "data-name": "Caminho 6393",
    d: "M21.1,24H2.9a.231.231,0,0,0-.061-.034A3.2,3.2,0,0,1,0,20.632Q0,12.886,0,5.14a3.822,3.822,0,0,1,.051-.723,3.256,3.256,0,0,1,3.3-2.638c.412,0,.823,0,1.262,0,0-.286,0-.55,0-.813A.918.918,0,0,1,5.542,0a.907.907,0,0,1,.915.974c0,.263,0,.525,0,.788H17.54c0-.094,0-.171,0-.248,0-.2,0-.406,0-.609a.9.9,0,0,1,.889-.9.909.909,0,0,1,.951.872c.015.294,0,.589,0,.908.473,0,.917,0,1.36,0A3.27,3.27,0,0,1,24,5.07q0,4.816,0,9.633c0,2.008,0,4.016,0,6.023a3.2,3.2,0,0,1-2.431,3.161c-.154.041-.31.076-.466.114M22.154,9.348H1.856c-.005.07-.012.123-.012.177q0,5.611,0,11.223A1.43,1.43,0,0,0,3.4,22.22H20.6a1.918,1.918,0,0,0,.363-.025,1.431,1.431,0,0,0,1.192-1.518q0-5.529,0-11.059ZM1.843,7.535H22.13c0-.938.036-1.859-.013-2.777a1.188,1.188,0,0,0-1.01-1.127,12.038,12.038,0,0,0-1.721-.1c0,.315,0,.573,0,.829a.924.924,0,1,1-1.845,0c0-.263,0-.525,0-.784H6.456a6.229,6.229,0,0,1-.01.88,1.2,1.2,0,0,1-.247.587.853.853,0,0,1-.972.235.891.891,0,0,1-.613-.848c-.008-.285,0-.571,0-.873-.432,0-.828,0-1.224,0A1.433,1.433,0,0,0,1.844,5.04c-.005.5,0,1,0,1.5v.995",
    transform: "translate(0 0)",
    fill: "#f78a2f"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAgendamento, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_agendamento.dd654087.svg";
export { ForwardRef as ReactComponent };